<e-dialog
  [open]="target() !== null"
  (openChange)="onOpenChange($event)"
  [title]="text().title"
  [titleData]="target()?.chartName ?? ''"
  size="lg"
>
  <ng-template>
    <div class="moments-dialog">
      <input
        class="moments-dialog__search"
        type="search"
        [placeholder]="text().searchPlaceholder"
        [ngModel]="search()"
        (ngModelChange)="onSearchChange($event)"
      />

      @if (filteredRows().length === 0) {
        <div class="moments-dialog__empty">{{ text().none }}</div>
      } @else {
        <div class="moments-dialog__list">
          @for (row of pageRows(); track row.relation.id) {
            <button type="button" class="moments-dialog__row"
                    [disabled]="!row.relation.otherChartId"
                    (click)="openRow(row)">
              @if (row.colorHex) {
                <span class="moments-dialog__color-dot" [style.background]="row.colorHex"></span>
              }
              <i [class]="'fas fa-' + row.icon + ' moments-dialog__icon'" aria-hidden="true"></i>
              <span class="moments-dialog__name">{{ row.name }}</span>
              @if (row.hasNote) {
                <i class="fas fa-note-sticky moments-dialog__indicator" [title]="text().hasNote" aria-hidden="true"></i>
              }
              @if (row.attachmentCount > 0) {
                <span class="moments-dialog__indicator" [title]="text().hasAttachments">
                  <i class="fas fa-paperclip" aria-hidden="true"></i>{{ row.attachmentCount }}
                </span>
              }
              @if (row.momentText) {
                <span class="moments-dialog__moment">{{ row.momentText }}</span>
              }
            </button>
          }
        </div>

        <e-paginator
          [currentPage]="page()"
          [pageSize]="pageSize"
          [totalCount]="filteredRows().length"
          (currentPageChange)="page.set($event)"
        ></e-paginator>
      }
    </div>
  </ng-template>
</e-dialog>
